'use client';

import React, { FC } from 'react';
import { TypeNavFeaturedProductFields } from '@/core/generated-types';
import { Image } from '@/components/ui';
import { slugBuilder } from '@/core/contentfulConfig';
import { Link } from '@/navigation';

export const NavFeaturedProduct: FC<TypeNavFeaturedProductFields> = ({
  entryName: _entryName,
  title,
  media,
  link,
}) => {
  const href = slugBuilder(link);

  return (
    <Link
      href={href}
      data-testid="nav-featured-product"
      className="py-3 md:py-0 first:pt-0 last:pb-0"
    >
      {media && <Image imageData={media} alt={media.fields.altText} />}
      <div className="text-sm mt-[6px]">{title}</div>
    </Link>
  );
};

export default React.memo(NavFeaturedProduct);
